import { render, staticRenderFns } from "./CampaignSection.vue?vue&type=template&id=e0928062&"
import script from "./CampaignSection.vue?vue&type=script&lang=ts&"
export * from "./CampaignSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports